
const PopupSuccess = ({fio, manager, meettype, time, project, close, eventTypeId}) => {

    const formatDate = () => {
        var d = time.date.split('.'),
          month = d[1],
          day = d[0],
          year = d[2];
          
        if (month == 1) month = 'января'
        if (month == 2) month = 'февраля'
        if (month == 3) month = 'марта'
        if (month == 4) month = 'апреля'
        if (month == 5) month = 'мая'
        if (month == 6) month = 'июня'
        if (month == 7) month = 'июля'
        if (month == 8) month = 'августа'
        if (month == 9) month = 'сентября'
        if (month == 10) month = 'октября'
        if (month == 11) month = 'ноября'
        if (month == 12) month = 'декабря'
        
        return day + ' ' + month +  ' ' + year + ' в ' + time.period.split('-')[0]
    }

    return (
        <div className="popup-meeting">
            <div className="popup-meeting__close" onClick={close}></div>
            <div className="popup-meeting__wrap">
            <div className="popup-meeting__title">Вы записаны на&nbsp;{eventTypeId == 1 ? 'встречу' : 'брокер-тур'}</div>
            {eventTypeId == 2 && <div className="popup-meeting__status popup-meeting__status_success">Брокер-тур по&nbsp;проекту {project}  состоится </div>}
            {eventTypeId == 1 && <div className="popup-meeting__status popup-meeting__status_success">{fio} записан на&nbsp;встречу </div>}
            <div className="popup-meeting__meet">
                {formatDate()}
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="22" viewBox="0 0 8 22" fill="none">
                <path d="M6.67627 1.34082L1.49989 20.6593" stroke="#2D2D2C" stroke-linecap="square"/>
                </svg>
                {meettype == '1' ? 'ОНЛАЙН' : 'ОФИС ПРОДАЖ'} <br/>
                Менеджер: {manager}
            </div>
            <div className="popup-meeting__buy">{eventTypeId == 1 ? 'Благодарим за обращение!' : 'До встречи!'}</div>
            </div>
        </div>
    )
}

export default PopupSuccess